import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useAuthDialog } from '../auth/AuthDialogContext';
import { HomePage } from './HomePage';

export function AuthPage() {
  const { mode } = useParams();
  const { user } = useAuth();
  const { openAuth } = useAuthDialog();
  const nextMode = mode === 'register' ? 'register' : 'login';

  useEffect(() => {
    if (!user) openAuth(nextMode);
  }, [nextMode, openAuth, user]);

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <HomePage />;
}
